import React, { AnchorHTMLAttributes, FC } from "react";
import styled from "styled-components";
import { BORDER_RADIUS } from "../calculation/theme";
import { imagePath } from "../image/util";

const DownloadButton: FC<AnchorHTMLAttributes<HTMLAnchorElement>> = ({ ...props }) => {
  return (
    <Root {...props} href={imagePath("/寄附金税額控除に係る申告特例申請書.pdf")} download>
      こちらからDL
    </Root>
  );
};
export default DownloadButton;

const Root = styled.a`
  padding: 10px;
  background-color: #1a1a1a;
  color: #fff;
  ${BORDER_RADIUS};
  @media screen and (min-width: 961px) {
    padding: 10px 20px;
  }
`;
